module.exports = __webpack_public_path__ + "media/audios/kid/lesson_7/audio44-89484c8e5cb2ff4ee3d5268b61bbce0b.m4a";